/**
 * Sets the tab index.
 * @param {number} index - The tab index.
 * @return {void}
 */
function setActiveTab(index) {
  activeTab = index;
  const indicator = document.querySelector(
    '.moduleGalaxyOneProductSlider__active-tab',
  );
  indicator.style.transform = `translateX(${activeTab * 100}%) scaleX(0.95)`;
}

let activeTab = 0;

const tabs = document.querySelectorAll('.moduleGalaxyOneProductSlider__tab');

// dynamically change active pill size
const activeTabIndicator = document.querySelector(
  '.moduleGalaxyOneProductSlider__active-tab',
);
activeTabIndicator.style.width = 100 / tabs.length + '%';

const descs = document.querySelectorAll(
  '.moduleGalaxyOneProductSlider__description',
);
const imgs = document.querySelectorAll(
  '.moduleGalaxyOneProductSlider__trade-img',
);
const section = document.querySelector(
  '.section--moduleGalaxyOneProductSlider',
);
descs[0].classList.add('active');
imgs[0].classList.add('active');

tabs.forEach((tab, i) => {
  tab.style.flexBasis = 100 / tabs.length + '%';
  if (i === 0) {
    tab.classList.add('active');
    tab.hasAttribute('data-omit') ?
      section.classList.add('omit-circle') :
      section.classList.remove('omit-circle');
  }
  tab.addEventListener('click', () => {
    tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    tab.hasAttribute('data-omit') ?
      section.classList.add('omit-circle') :
      section.classList.remove('omit-circle');
    descs.forEach((desc) => {
      desc.classList.remove('active');
    });
    imgs.forEach((img) => {
      img.classList.remove('active');
    });
    setActiveTab(i);
    tab.classList.add('active');
    descs[i].classList.add('active');
    imgs[i].classList.add('active');
  });
});
